import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import i18n from "@/i18n";
import App from "@/App";

// Keep <html lang="..."> in sync with the active language for a11y & SEO
document.documentElement.lang = i18n.language || "en";
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
